import React, { useEffect, useState } from 'react'
import MessageCenter from '@components/pages/Messages/MessageCenter.component'
import { Container } from 'react-bootstrap'
import '../../App.css'
import './MessageStyle.css'
import { useLocation } from 'react-router-dom'
import GoBackButton from '@components/common/GoBackButton/GoBackButton.component'
import { useAppDispatch } from '@store/hooks'
import { SET_ACTIVE_TAB } from '@store/reducers/messageCenter.reducer'

const VALID_MESSAGE_TABS = ['contact', 'chat', 'calls', 'fax', 'email'] as const

function Message(): React.ReactElement {
  const location = useLocation()
  const dispatch = useAppDispatch()
  const { previousPage } = location.state || {}
  const [pagePreviousState, setPagePreviousState] = useState<any>(previousPage)

  useEffect(() => {
    const nextPreviousPage = (
      location.state as { previousPage?: unknown } | null | undefined
    )?.previousPage
    if (nextPreviousPage) {
      setPagePreviousState(nextPreviousPage)
    }
  }, [location.state])

  // Notification deep-link tab switch. The Calls notification (and any other
  // /message deep-link) carries `location.state.tab` so we can land the user
  // on the right tab regardless of what they last viewed. We don't clear
  // `location.state` here — MessageCenterCalls owns the rest of the payload
  // (e.g. `callId`) and clears state once it has fully consumed it.
  useEffect(() => {
    const tab = (location.state as { tab?: string } | null | undefined)?.tab
    if (!tab) return
    if ((VALID_MESSAGE_TABS as readonly string[]).includes(tab)) {
      // SET_ACTIVE_TAB is a no-op when the value matches, so re-dispatching
      // on every `location.state` change is safe and avoids needing a ref to
      // dedupe by tab name (which would break re-deeplinks after a manual
      // user tab switch).
      dispatch(SET_ACTIVE_TAB(tab))
    }
  }, [location.state, dispatch])

  return (
    <Container fluid className="message-container-page">
      {pagePreviousState && (
        <GoBackButton previousPageState={pagePreviousState} />
      )}
      <MessageCenter />
    </Container>
  )
}

export default Message
